module.exports = __webpack_public_path__ + "img/logo.1809a98b.svg";